import client from './client';

export type SyncScope = 'all' | 'my_photos' | 'selected';
export type SyncStatus = 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';

export interface SyncJob {
  _id: string;
  status: SyncStatus;
  scope: SyncScope;
  totalPhotos: number;
  syncedPhotos: number;
  failedPhotos: number;
  failedPhotoIds: string[];
  googleAlbumUrl?: string;
  error?: string;
  startedAt: string;
  completedAt?: string;
}

export const googlePhotosApi = {
  getStatus: () =>
    client.get<{ connected: boolean }>('/auth/google-photos/status').then((r) => r.data),

  connectUrl: (albumId: string) =>
    `/api/v1/auth/google-photos/connect?albumId=${albumId}`,

  disconnect: () =>
    client.delete('/auth/google-photos/disconnect').then((r) => r.data),

  startSync: (albumId: string, opts: { scope: SyncScope; photoIds?: string[] }) =>
    client
      .post<{ jobId: string; alreadyRunning?: boolean }>(`/albums/${albumId}/sync/google-photos`, opts)
      .then((r) => r.data),

  cancelSync: (albumId: string) =>
    client.delete(`/albums/${albumId}/sync/google-photos`).then((r) => r.data),

  getSyncStatus: (albumId: string) =>
    client.get<{ job: SyncJob | null }>(`/albums/${albumId}/sync/google-photos/status`).then((r) => r.data),

  getSyncedPhotoIds: (albumId: string) =>
    client.get<{ syncedPhotoIds: string[] }>(`/albums/${albumId}/sync/google-photos/synced`).then((r) => r.data),

  getSyncedPhotos: (albumId: string) =>
    client.get<{ photos: import('../types').Photo[]; syncedPhotoIds: string[] }>(`/albums/${albumId}/sync/google-photos/synced-photos`).then((r) => r.data),

  retryPhoto: (albumId: string, photoId: string) =>
    client.post<{ success: boolean }>(`/albums/${albumId}/sync/google-photos/retry-photo`, { photoId }).then((r) => r.data),
};
